import { Eyebrow, Reveal } from "./Reveal";
import { aboutHighlights, images } from "../data/business";

export default function About() {
    return (
        <section id="sobre" data-testid="about-section" className="border-y border-line bg-cream py-20 sm:py-28 lg:py-36">
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-16">
                <Reveal className="relative order-1 lg:col-span-5">
                    <div className="absolute -left-3 -bottom-3 h-full w-full border border-accent/40 sm:-left-5 sm:-bottom-5" />
                    <img
                        src={images.portrait}
                        alt="Danielly Sousa — nail designer e instrutora"
                        loading="lazy"
                        className="relative aspect-[4/5] w-full object-cover object-top"
                        style={{ objectPosition: "50% 25%" }}
                    />
                </Reveal>

                <div className="order-2 lg:col-span-7 lg:pl-8">
                    <Eyebrow>Conheça a profissional</Eyebrow>
                    <Reveal delay={0.1}>
                        <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.08] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            Paixão pelas unhas
                            <br />
                            que se transformou
                            <br />
                            <span className="italic text-accent">em profissão.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <div className="mt-6 max-w-xl space-y-4 text-sm leading-relaxed text-ink-soft sm:text-base">
                            <p>
                                Danielly Pereira Teixeira de Souza iniciou sua trajetória
                                como manicure convencional em 2015 e continuou evoluindo
                                profissionalmente no universo das unhas.
                            </p>
                            <p>
                                Hoje, à frente do Studio Danielly Sousa, une técnica,
                                cuidado e conhecimento tanto nos atendimentos quanto em
                                sua atuação como instrutora.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.3}>
                        <div className="mt-9 flex flex-wrap gap-3">
                            {aboutHighlights.map((h) => (
                                <span
                                    key={h}
                                    className="border border-ink/15 bg-paper px-4 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-ink"
                                >
                                    {h}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
